{
  "asyncapi": "3.1.0",
  "info": {
    "title": "Springwolf example project - SNS",
    "version": "1.0.0",
    "description": "Springwolf [example project](https://github.com/springwolf/springwolf-core/tree/main/springwolf-examples/springwolf-sns-example) to demonstrate springwolfs abilities, including **markdown** support for descriptions.",
    "termsOfService": "https://asyncapi.org/terms",
    "contact": {
      "name": "springwolf",
      "url": "https://github.com/springwolf/springwolf-core",
      "email": "example@example.com"
    },
    "license": {
      "name": "Apache License 2.0"
    },
    "x-generator": "springwolf"
  },
  "defaultContentType": "application/json",
  "servers": {
    "sns-server": {
      "host": "http://localhost:4566",
      "protocol": "sns"
    }
  },
  "channels": {
    "another-topic": {
      "address": "another-topic",
      "messages": {
        "io.github.springwolf.examples.sns.dtos.AnotherPayloadDto": {
          "$ref": "#/components/messages/io.github.springwolf.examples.sns.dtos.AnotherPayloadDto"
        }
      },
      "bindings": { }
    },
    "example-topic": {
      "address": "example-topic",
      "messages": {
        "io.github.springwolf.examples.sns.dtos.ExamplePayloadDto": {
          "$ref": "#/components/messages/io.github.springwolf.examples.sns.dtos.ExamplePayloadDto"
        }
      },
      "bindings": { }
    }
  },
  "components": {
    "schemas": {
      "HeadersNotDocumented": {
        "title": "HeadersNotDocumented",
        "type": "object",
        "properties": { },
        "description": "There can be headers, but they are not explicitly documented.",
        "examples": [
          { }
        ],
        "x-json-schema": {
          "$schema": "https://json-schema.org/draft-07/schema#",
          "description": "There can be headers, but they are not explicitly documented.",
          "title": "HeadersNotDocumented",
          "type": "object"
        }
      },
      "io.github.springwolf.examples.sns.dtos.AnotherPayloadDto": {
        "title": "AnotherPayloadDto",
        "type": "object",
        "properties": {
          "example": {
            "$ref": "#/components/schemas/io.github.springwolf.examples.sns.dtos.ExamplePayloadDto"
          },
          "foo": {
            "type": "string",
            "description": "Foo field",
            "maxLength": 100,
            "examples": [
              "bar"
            ]
          }
        },
        "description": "Another payload model",
        "examples": [
          {
            "example": {
              "someEnum": "FOO2",
              "someLong": 5,
              "someString": "some string value"
            },
            "foo": "bar"
          }
        ],
        "required": [
          "example"
        ],
        "x-json-schema": {
          "$schema": "https://json-schema.org/draft-07/schema#",
          "description": "Another payload model",
          "properties": {
            "example": {
              "description": "Example payload model",
              "properties": {
                "someEnum": {
                  "description": "Some enum field",
                  "enum": [
                    "FOO1",
                    "FOO2",
                    "FOO3"
                  ],
                  "title": "ExampleEnum",
                  "type": "string"
                },
                "someLong": {
                  "description": "Some long field",
                  "format": "int64",
                  "minimum": 0,
                  "type": "integer"
                },
                "someString": {
                  "description": "Some string field",
                  "type": "string"
                }
              },
              "required": [
                "someEnum",
                "someString"
              ],
              "title": "ExamplePayloadDto",
              "type": "object"
            },
            "foo": {
              "description": "Foo field",
              "maxLength": 100,
              "type": "string"
            }
          },
          "required": [
            "example"
          ],
          "title": "AnotherPayloadDto",
          "type": "object"
        }
      },
      "io.github.springwolf.examples.sns.dtos.ExamplePayloadDto": {
        "title": "ExamplePayloadDto",
        "type": "object",
        "properties": {
          "someEnum": {
            "title": "ExampleEnum",
            "type": "string",
            "description": "Some enum field",
            "enum": [
              "FOO1",
              "FOO2",
              "FOO3"
            ],
            "examples": [
              "FOO2"
            ]
          },
          "someLong": {
            "type": "integer",
            "description": "Some long field",
            "format": "int64",
            "minimum": 0,
            "examples": [
              5
            ]
          },
          "someString": {
            "type": "string",
            "description": "Some string field",
            "examples": [
              "some string value"
            ]
          }
        },
        "description": "Example payload model",
        "examples": [
          {
            "someEnum": "FOO2",
            "someLong": 5,
            "someString": "some string value"
          }
        ],
        "required": [
          "someEnum",
          "someString"
        ],
        "x-json-schema": {
          "$schema": "https://json-schema.org/draft-07/schema#",
          "description": "Example payload model",
          "properties": {
            "someEnum": {
              "description": "Some enum field",
              "enum": [
                "FOO1",
                "FOO2",
                "FOO3"
              ],
              "title": "ExampleEnum",
              "type": "string"
            },
            "someLong": {
              "description": "Some long field",
              "format": "int64",
              "minimum": 0,
              "type": "integer"
            },
            "someString": {
              "description": "Some string field",
              "type": "string"
            }
          },
          "required": [
            "someEnum",
            "someString"
          ],
          "title": "ExamplePayloadDto",
          "type": "object"
        }
      }
    },
    "messages": {
      "io.github.springwolf.examples.sns.dtos.AnotherPayloadDto": {
        "headers": {
          "$ref": "#/components/schemas/HeadersNotDocumented"
        },
        "payload": {
          "schemaFormat": "application/vnd.aai.asyncapi+json;version=3.1.0",
          "schema": {
            "$ref": "#/components/schemas/io.github.springwolf.examples.sns.dtos.AnotherPayloadDto"
          }
        },
        "name": "io.github.springwolf.examples.sns.dtos.AnotherPayloadDto",
        "title": "AnotherPayloadDto",
        "bindings": {
          "sns": { }
        }
      },
      "io.github.springwolf.examples.sns.dtos.ExamplePayloadDto": {
        "headers": {
          "$ref": "#/components/schemas/HeadersNotDocumented"
        },
        "payload": {
          "schemaFormat": "application/vnd.aai.asyncapi+json;version=3.1.0",
          "schema": {
            "$ref": "#/components/schemas/io.github.springwolf.examples.sns.dtos.ExamplePayloadDto"
          }
        },
        "name": "io.github.springwolf.examples.sns.dtos.ExamplePayloadDto",
        "title": "ExamplePayloadDto",
        "bindings": {
          "sns": { }
        }
      }
    }
  },
  "operations": {
    "another-topic_receive_receiveAnotherPayload": {
      "action": "receive",
      "channel": {
        "$ref": "#/channels/another-topic"
      },
      "title": "another-topic_receive",
      "description": "Auto-generated description",
      "bindings": {
        "sns": {
          "consumers": [
            {
              "protocol": "sqs",
              "endpoint": { },
              "filterPolicyScope": "MessageAttributes",
              "rawMessageDelivery": true
            }
          ],
          "bindingVersion": "0.1.0"
        }
      },
      "messages": [
        {
          "$ref": "#/channels/another-topic/messages/io.github.springwolf.examples.sns.dtos.AnotherPayloadDto"
        }
      ]
    },
    "another-topic_send_sendMessage": {
      "action": "send",
      "channel": {
        "$ref": "#/channels/another-topic"
      },
      "title": "another-topic_send",
      "description": "Custom, optional description defined in the AsyncPublisher annotation",
      "bindings": {
        "sns": {
          "consumers": [
            {
              "protocol": "sqs",
              "endpoint": { },
              "filterPolicyScope": "MessageAttributes",
              "rawMessageDelivery": true
            }
          ],
          "bindingVersion": "0.1.0"
        }
      },
      "messages": [
        {
          "$ref": "#/channels/another-topic/messages/io.github.springwolf.examples.sns.dtos.AnotherPayloadDto"
        }
      ]
    },
    "example-topic_receive_receiveExamplePayload": {
      "action": "receive",
      "channel": {
        "$ref": "#/channels/example-topic"
      },
      "title": "example-topic_receive",
      "description": "Auto-generated description",
      "bindings": {
        "sns": {
          "consumers": [
            {
              "protocol": "sqs",
              "endpoint": { },
              "filterPolicyScope": "MessageAttributes",
              "rawMessageDelivery": true
            }
          ],
          "bindingVersion": "0.1.0"
        }
      },
      "messages": [
        {
          "$ref": "#/channels/example-topic/messages/io.github.springwolf.examples.sns.dtos.ExamplePayloadDto"
        }
      ]
    }
  }
}